/* React */
import { Component } from "react"
/* Redux connect */
import { connect } from "react-redux"

/* Icon component */
import Icon from "./Icon"
/* Category icon component */
import CatIcon from "./CatIcon"

/* Translation */
import { translate } from "../translates"

const NAME_SLUG = {
    "Маникюр": "nails", "Наращивание ногтей": "ext", "Педикюр": "pedi", "Снятие покрытия": "remove", "Подология": "podo",
    "Стрижка волос": "haircut", "Укладка волос": "styling", "Брейдинг": "braiding", "Окрашивание": "color",
    "Наращивание ресниц": "lashes", "Брови": "brows", "Ламинирование": "lami",
    "Массаж": "massage", "Косметология": "face", "SPA": "spa",
    "Автомойка": "wash", "Шиномонтаж": "tires", "СТО · ремонт": "sto", "Детейлинг": "detail", "Полировка": "polish"
}

/* Component ServicePickerModal */
class ServicePickerModal extends Component {

    constructor(props) {
        super(props)
        /* State */
        this.state = { query: "" }
    }

    componentDidMount = () => {
        document.addEventListener("keydown", this._onKey)
        document.body.style.overflow = "hidden"
    }

    componentWillUnmount = () => {
        document.removeEventListener("keydown", this._onKey)
        document.body.style.overflow = ""
    }

    /* Draw On Key */
    _onKey = (event) => {
        if (event.key === "Escape") {
            this.props.onClose()
        }
    }

    /* Draw Filtered */
    _filtered = () => {
        /* Fields */
        const { categories } = this.props
        const { query } = this.state
        if (!Array.isArray(categories)) {
            return []
        }
        if (!query) {
            return categories
        }
        return categories.filter((category) => category.name.toLowerCase().includes(query.toLowerCase()))
    }

    /* Draw Grouped */
    _grouped = () => {
        const filtered = this._filtered()
        const groups = {}
        filtered.forEach((category) => {
            const groupName = category.group || translate("Услуги")
            if (!groups[groupName]) {
                groups[groupName] = []
            }
            groups[groupName].push(category)
        })
        return groups
    }

    render = () => {
        /* Fields */
        const { onClose, value, onSelect } = this.props
        const { query } = this.state
        const grouped = this._grouped()
        const groupEntries = Object.entries(grouped)
        const filtered = this._filtered()

        return (
            <div className="modal-backdrop" onClick={onClose}>
                <div className="modal modal--lg" onClick={(event) => event.stopPropagation()}>
                    <div className="modal__header">
                        <h3 className="modal__title">{translate("Выберите услугу")}</h3>
                        <button className="modal__close" onClick={onClose} aria-label={translate("Закрыть")}>
                            <Icon name="close" size={20} />
                        </button>
                    </div>
                    <div className="modal__body" style={{ padding: 24 }}>
                        <div className="search" style={{ marginBottom: 20, background: "var(--bg-soft)" }}>
                            <span className="search__icon"><Icon name="search" size={18} /></span>
                            <input
                                className="search__input"
                                placeholder={translate("Маникюр, стрижка, автомойка...")}
                                value={query}
                                onChange={(event) => this.setState({ query: event.target.value })}
                                autoFocus
                            />
                        </div>
                        {groupEntries.map(([groupName, items]) => (
                            <div key={groupName} style={{ marginBottom: 24 }}>
                                <div style={{ fontSize: 12, fontWeight: 700, color: "var(--muted)", textTransform: "uppercase", letterSpacing: "0.06em", marginBottom: 12 }}>
                                    {translate(groupName)}
                                </div>
                                <div className="allcats__grid">
                                    {items.map((category) => (
                                        <button
                                            key={`${category.id}`}
                                            className={`allcat${value === category.name ? " is-selected" : ""}`}
                                            onClick={() => { onSelect(category); onClose() }}
                                        >
                                            <span className="allcat__icon">
                                                <CatIcon cat={category.slug || NAME_SLUG[category.name]} size={24} />
                                            </span>
                                            <span className="allcat__name">{translate(category.name)}</span>
                                        </button>
                                    ))}
                                </div>
                            </div>
                        ))}
                        {filtered.length === 0 && (
                            <div style={{ padding: "40px 0", textAlign: "center", color: "var(--muted)" }}>
                                {translate("Ничего не нашлось по запросу")} «{query}»
                            </div>
                        )}
                    </div>
                </div>
            </div>
        )
    }
}

/* Map State To Props */
const mapStateToProps = state => {
    return {
        categories: state.data && state.data.categories ? state.data.categories : [],
        lang: state.lang
    }
}

/* Export */
export default connect(mapStateToProps)(ServicePickerModal)
